import React, { useState } from 'react';

interface PasswordGateProps {
  onSubmit: (password: string) => boolean;
  isTestMode: boolean;
}

const PasswordGate: React.FC<PasswordGateProps> = ({ onSubmit, isTestMode }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const isCorrect = onSubmit(password);
    
    if (!isCorrect) {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 px-4">
      <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Daniel & Anthea - Wedding Gallery</h2>
        <p className="text-gray-600 mb-6">This content is password protected.</p>
        
        {isTestMode && (
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded mb-6">
            <p className="text-sm">Running in test mode</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="password" className="block text-gray-700 text-sm font-medium mb-2">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
              required
            />
          </div>
          
          {error && (
            <div className="mb-6 text-red-600 text-sm">
              {error}
            </div>
          )}
          
          <button 
            type="submit" 
            className="w-full bg-primary hover:bg-primary-dark text-white font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            Enter Gallery
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordGate;